import React from 'react'

import { DEFAULT_COLORS } from './_defaults/colors'
import { DEFAULT_FONT_SIZES } from './_defaults/fontSizes'
import { invertColors } from '../../utils/helpers/colors'

const defaultState = { fontSizes: DEFAULT_FONT_SIZES, colors: DEFAULT_COLORS }
export const ThemeContext = React.createContext(defaultState)
export const useThemeState = () => React.useContext(ThemeContext)
export const useTheme = () => useThemeState()?.theme
const { Provider } = ThemeContext

export const ThemeHandler = ({ children, fontSizes, colors }) => {
  const [theme, setTheme] = React.useState('light')
  const state = {
    theme,
    fontSizes: fontSizes || DEFAULT_FONT_SIZES,
    colors: invertColors(colors || DEFAULT_COLORS, theme),
    setTheme
  }

  return <Provider value={state}>{children}</Provider>
}
